export default __webpack_public_path__ + "static/media/a8.48be2094.png";